module.exports = __webpack_public_path__ + "static/media/mainLogo.bd203bdd.png";